export const INSTANCE_STATUS = {
  ACTIVATED: 'ACTIVATED',
  UNREGISTERED: 'UNREGISTERED',
} as const;

export type InstanceStatus = (typeof INSTANCE_STATUS)[keyof typeof INSTANCE_STATUS];

export const REGISTRATION_KEY_STATUS = {
  ACTIVE: 'ACTIVE',
  CONSUMED: 'CONSUMED',
  EXPIRED: 'EXPIRED',
  REVOKED: 'REVOKED',
} as const;

export type RegistrationKeyStatus = (typeof REGISTRATION_KEY_STATUS)[keyof typeof REGISTRATION_KEY_STATUS];

/**
 * Value shown in the instance list "Key status" column: a known registration-key
 * status, `'UNKNOWN'` for a value the API returned that we don't recognise
 * (contract violation — surfaced rather than silently mislabelled), or `null`
 * when the instance has no key.
 */
export type InstanceKeyStatus = RegistrationKeyStatus | 'UNKNOWN';

export interface InstanceRow {
  id: string;
  organizationId: string;
  name: string;
  computerName: string | null;
  email: string | null;
  path: string | null;
  codeterrain: string[];
  version: string | null;
  genVersion: string | null;
  pays: string | null;
  registeredAt: string | null;
  status: InstanceStatus;
  /** Current registration-key status (server-computed); `'UNKNOWN'` if unrecognised, `null` when the instance has no keys. */
  keyStatus: InstanceKeyStatus | null;
  createdAt: string;
  updatedAt: string;
}

export interface RegistrationKey {
  id: string;
  hint: string;
  status: RegistrationKeyStatus;
  createdAt: string;
  expiresAt: string;
  usedAt: string | null;
  revokedAt: string | null;
}

export interface GeneratedKey {
  key: string;
  hint: string;
  expiresAt: string;
}

export interface Terrain {
  codeterrain: string;
  libelle: string;
  pays: string;
}

export const INSTANCE_QUICK_FILTER_FIELDS: (keyof InstanceRow)[] = [
  'name', 'registeredAt', 'codeterrain', 'createdAt',
  'computerName', 'email', 'version', 'updatedAt',
];

export type InstanceStatusFilter = 'registered' | 'pending';

export interface InstanceFilters {
  computerName?: string;
  instanceName?: string;
  email?: string;
  codeterrain?: string[];
  version?: string;
  status?: InstanceStatusFilter[];
  createdAt?: string;
}

export interface CreateInstancePayload {
  instance_name?: string;
  email: string;
  codeterrain: string[];
}

export interface UpdateInstancePayload {
  instance_name?: string;
  computer_name?: string;
  email?: string;
  codeterrain?: string[];
}
